// Opt-in only after the new member HTTP routes and same-origin deployment pass acceptance.
export const cookieAuthEnabled = process.env.VUE_APP_AUTH_MODE === 'cookie'

const csrfKey = 'spark-member-csrf'
const sessionMarkerKey = 'spark-member-session-marker'

export function saveCookieAuthState(csrfToken) {
  if (!/^[A-Za-z0-9_-]{43}$/.test(csrfToken || '')) {
    throw new Error('Invalid member CSRF proof')
  }
  sessionStorage.setItem(csrfKey, csrfToken)
  sessionStorage.setItem(sessionMarkerKey, '1')
}

export function getMemberCsrf() {
  return cookieAuthEnabled ? sessionStorage.getItem(csrfKey) || '' : ''
}

export function hasCookieSessionMarker() {
  return cookieAuthEnabled && sessionStorage.getItem(sessionMarkerKey) === '1'
}

export function clearCookieAuthState() {
  sessionStorage.removeItem(csrfKey)
  sessionStorage.removeItem(sessionMarkerKey)
}
